import React, { memo, useEffect } from 'react';
import propTypes from 'prop-types';
import InfoIcon24 from '../../../resources/images/alert-triangle-28.svg';
import Button from '../../global/atoms/button';
import GlobalModal from '../../global/atoms/globalModal/GlobalModal';
import { getEmailVerificationObject } from '../../guidedReg/utils/guidedUtil';
import { AEM_CONTAINS_PHONE_NUMBER } from '../../guidedReg/constants.js';
import { useAnalyticsContext } from '../../../config/GoogleTagManagerEvents';
import { EVENT_ECOMMERCE_NAMES_CONFIG } from '../../../constants/analyticsConstants/Ecommerce';
import { VerificationTimeOutTestId } from '../GRTestId.js';
import './VerificationFailedModal.scss';
import { convertPhoneNumberAsPerSbmChannel } from '../../global/utils/commonUtils.js';

const VerificationFailedModal = ({ failedModal, hideFailedModal, resendCode }) => {
    const emailVerificationFailedData = getEmailVerificationObject();
    const {
        resendCodeButtonLabel = '',
        verificationFailedDescription = '',
        verificationFailedTitle = '',
        contactUsField = ''
    } = emailVerificationFailedData || {};

    const { sendEventsForGRModalOpened, sendEventsForGRModalCTAClicked, sendEventsForGRModalCompleted } =
        useAnalyticsContext();

    const phoneNumber = convertPhoneNumberAsPerSbmChannel(contactUsField);

    const [verificationContent = '', verificationContact = ''] =
        verificationFailedDescription.split(AEM_CONTAINS_PHONE_NUMBER) || [];

    useEffect(() => {
        if (failedModal) {
            sendEventsForGRModalOpened(
                EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_FORM_VIEWED,
                EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_MODAL_VERIFICATION_FAILED,
                EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CCA_INFORMATION,
                ''
            );
        }
    }, []);

    const handleResendCode = () => {
        hideFailedModal();
        resendCode();
        sendEventsForGRModalCompleted(
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_FORM_COMPLETED,
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_MODAL_VERIFICATION_FAILED,
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CCA_INFORMATION,
            resendCodeButtonLabel
        );
    };

    const failedVerificationTitle = () => {
        return (
            <>
                <InfoIcon24 tabIndex={'-1'} aria-hidden={true} />
                <span>{verificationFailedTitle}</span>
            </>
        );
    };

    const sendClickEvent = label => {
        sendEventsForGRModalCTAClicked(
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CTA_CLICKED,
            label,
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CCA_BUTTON,
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CCA_MODAL,
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_FORM_PHONE
        );
    };

    const failedVerificationContent = () => {
        return (
            <>
                {verificationContent}{' '}
                <a
                    href={`tel:${phoneNumber}`}
                    onClick={() => sendClickEvent(verificationContact)}
                    data-testid={VerificationTimeOutTestId.MODAL_DESCRIPTION}>
                    <strong>{verificationContact}</strong>
                </a>
                <div className="helpmodal__actions">
                    {resendCodeButtonLabel && (
                        <Button
                            dataTestid={VerificationTimeOutTestId.RESEND_BUTTON}
                            tabIndex={0}
                            buttonAriaLabel={resendCodeButtonLabel}
                            className={`button button-primary button-block`}
                            onClick={handleResendCode}>
                            {resendCodeButtonLabel}
                        </Button>
                    )}
                </div>
            </>
        );
    };

    return (
        <>
            <GlobalModal
                titleClasses={'email-verification_title'}
                className={'width-327'}
                isOpen={failedModal}
                onRequestClose={hideFailedModal}
                title={failedVerificationTitle()}
                content={failedVerificationContent()}
                handleClose={hideFailedModal}
            />
        </>
    );
};

export default memo(VerificationFailedModal);

VerificationFailedModal.propTypes = {
    failedModal: propTypes.bool,
    hideFailedModal: propTypes.func
};
